import { ApiClientService, EntityApiService } from '@dofleini/security';
import { cnae } from '@mep/pae-commons';

import { authentication } from '@/settings';
const { BULK_ACTIONS } = cnae;

class CNAENomenclatorApiService extends EntityApiService {
    getGroups = async (params) => {
      const response = await ApiClientService.get(this.getPath('/groups'), params);
      return response?.data;
    }

    getDivisions = async (params) => {
      const response = await ApiClientService.get(this.getPath('/divisions'), params);
      return response?.data;
    }

    getSections = async (params) => {
      const response = await ApiClientService.get(this.getPath('/sections'), params);
      return response?.data;
    }

    prohibitMany = (params, config) => {
      return ApiClientService.post(this.getPath(null, params) + `/${BULK_ACTIONS.PROHIBIT}`, params, config);
    };

    allowMany = (params, config) => {
      return ApiClientService.post(this.getPath(null, params) + `/${BULK_ACTIONS.ALLOW}`, params, config);
    };

    activateMany = (params, config) => {
      return ApiClientService.post(this.getPath(null, params) + `/${BULK_ACTIONS.ACTIVATE}`, params, config);
    };

    deactivateMany = (params, config) => {
      return ApiClientService.post(this.getPath(null, params) + `/${BULK_ACTIONS.DEACTIVATE}`, params, config);
    };
}

export default new CNAENomenclatorApiService(`${authentication.path}/api/cnae-activities`);
